import React from "react";
import { useTheme } from "../../app/providers/ThemeProvider";

const buttonBaseStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  padding: "10px 14px",
  borderRadius: "999px",
  border: "1px solid var(--border)",
  background: "var(--surface)",
  color: "var(--text-primary)",
  backdropFilter: "var(--glass)",
  WebkitBackdropFilter: "var(--glass)",
  boxShadow: "var(--shadow)",
  cursor: "pointer",
  transition: "all var(--transition-base)",
  fontSize: "14px",
  fontWeight: 600
};

export const ThemeToggle = () => {
  const { mode, toggleTheme } = useTheme();

  return (
    <button type="button" onClick={toggleTheme} style={buttonBaseStyle}>
      <span>{mode === "dark" ? "🌙" : "☀️"}</span>
      <span>{mode === "dark" ? "Dark" : "Light"}</span>
    </button>
  );
};